module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('building-blank-form', {
    attrs: {
      "submit-label": "Добавить дом",
      "building": _vm.building,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processBuildingForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a5d6490","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/building/BuildingAddForm.vue
// module id = 689
// module chunks = 0